import { useAppMutation } from '@alluradirect/react';

const url = '/RESTAUTH/guest/inquiry/';

interface SendData {
  id: number;
  property_id: number;
  is_direct_vacations: boolean;
  message: string;
  adults?: number;
  children?: number;
  infants?: number;
  pets?: number;
  arrival?: string;
  departure?: string;
}

export const useGuestContactHostMutation = () => {
  return useAppMutation<SendData>({
    url,
    method: 'POST',
  });
};
